// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2kXzK","label":"LabeledBox_label__2VqEn"};